import { CSSProperties } from 'react'

export const getLabelStyle = (label: string): CSSProperties => {
  if (!label) return undefined

  let fontSize: CSSProperties['fontSize']
  const labelLength = label.length

  switch (true) {
    case labelLength > 10 && labelLength < 16: {
      fontSize = 12
      break
    }
    case labelLength > 15 && labelLength < 21: {
      fontSize = 10
      break
    }
    case labelLength > 20: {
      fontSize = 9
      break
    }
    default: return undefined
  }

  return {
    fontSize,
    lineHeight: fontSize ? `${fontSize + 2}px` : undefined
  }
}
